<template>
  <div>
    <div v-if="caseLabtests(value) && caseLabtests(value).length > 0" class="labtest border-bottom shadow-sm">
      <div
        v-for="e in caseLabtests(value)"
        :key="`labtest-${e.id}`"
        class="row list no-gutters"
      >
        <div class="col-auto item result-type-value">
          <a class="py-2 px-3 h-100">
            <span class="text-success" v-if="e.result_type === 'present'">
              <yes-icon></yes-icon>
              {{ $t(e.result_type) }}
            </span>
            <span class="text-danger" v-else-if="e.result_type === 'absent'">
              <no-icon></no-icon>
              {{ $t(e.result_type) }}
            </span>
            <span class="text-danger" v-else-if="e.result_type === 'very_low'">
              <double-angle-icon></double-angle-icon>
              {{ $t(e.result_type) }}
            </span>
            <span class="text-warning" v-else-if="e.result_type === 'low'">
              <angle-icon></angle-icon>
              {{ $t(e.result_type) }}
            </span>
            <span class="text-primary" v-else-if="e.result_type === 'normal'">
              <normal-icon></normal-icon>
              {{ $t(e.result_type) }}
            </span>
            <span class="text-warning" v-else-if="e.result_type === 'high'">
              <angle-icon class="rotate-180"></angle-icon>
              {{ $t(e.result_type) }}
            </span>
            <span class="text-danger" v-else-if="e.result_type === 'very_high'">
              <double-angle-icon class="rotate-180"></double-angle-icon>
              {{ $t(e.result_type) }}
            </span>
          </a>
        </div>
        <div class="col item item-last">
          <a class="py-2 px-3" v-if="labtestById(e.id)">
            {{ labtestById(e.id).name[authLocale] }}
          </a>
        </div>
      </div>
    </div>
    <div v-else class="alert alert-secondary mt-3">
      {{ $t("nolabtests") }}
    </div>
  </div>
</template>
<script>
import YesIcon from '@/components/Icons/Yes'
import NoIcon from '@/components/Icons/No'
import AngleIcon from '@/components/Icons/Angle'
import DoubleAngleIcon from '@/components/Icons/DoubleAngle'
import NormalIcon from '@/components/Icons/Normal'
import { mapGetters } from 'vuex'
export default {
  components: {
    YesIcon,
    NoIcon,
    AngleIcon,
    DoubleAngleIcon,
    NormalIcon
  },
  props: {
    value: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      authLocale: 'auth/locale',
      labtests: 'labtest/labtests',
      labtestById: 'labtest/byId',
      caseById: 'pcase/byId',
      caseLabtests: 'pcase/labtests'
    })
  }
}
</script>
<style lang="scss">
.labtest {
  .labtest-list {
    max-height: 400px;
    overflow: auto;
  }
  .result-type-value {
    width: 185px;
  }
}
</style>
<i18n>
{
  "ka": {
    "addLabtests": "მონაცემის დამატება",
    "search": "ძიება",
    "present": "ფიქსირდება",
    "absent": "არ ფიქსირდება",
    "very_low": "ძალიან დაბალი",
    "low": "დაბალი",
    "normal": "ნორმა",
    "high": "მაღალი",
    "very_high": "ძალიან მაღალი",
    "nolabtests": "მონაცემები არ არის შეყვანილი"
  },
  "en": {
      "addLabtests": "Add Data",
      "search": "Search",
      "present": "Present",
      "absent": "Absent",
      "very_low": "Very Low",
      "low": "Low",
      "normal": "Normal",
      "high": "High",
      "very_high": "Very High",
      "nolabtests": "No Labtests Data"
  }
}
</i18n>
